export const PROVIDER_INFOS = {
    claude: {
        name: "claude",
        displayName: "Claude (Anthropic)",
        supportsStreaming: true,
        supportsTools: true,
        models: [
            {
                id: "claude-opus-4-6",
                displayName: "Claude Opus 4.6",
                contextWindow: 200000,
                inputCostPer1M: 15,
                outputCostPer1M: 75,
            },
            {
                id: "claude-sonnet-4-6",
                displayName: "Claude Sonnet 4.6",
                contextWindow: 200000,
                inputCostPer1M: 3,
                outputCostPer1M: 15,
            },
            {
                id: "claude-haiku-4-5-20251001",
                displayName: "Claude Haiku 4.5",
                contextWindow: 200000,
                inputCostPer1M: 0.25,
                outputCostPer1M: 1.25,
            },
        ],
    },
    openai: {
        name: "openai",
        displayName: "OpenAI",
        supportsStreaming: true,
        supportsTools: true,
        models: [
            {
                id: "gpt-4o",
                displayName: "GPT-4o",
                contextWindow: 128000,
                inputCostPer1M: 2.5,
                outputCostPer1M: 10,
            },
            {
                id: "gpt-4o-mini",
                displayName: "GPT-4o Mini",
                contextWindow: 128000,
                inputCostPer1M: 0.15,
                outputCostPer1M: 0.6,
            },
            {
                id: "o1",
                displayName: "o1",
                contextWindow: 200000,
                inputCostPer1M: 15,
                outputCostPer1M: 60,
            },
        ],
    },
    gemini: {
        name: "gemini",
        displayName: "Gemini (Google)",
        supportsStreaming: true,
        supportsTools: true,
        models: [
            {
                id: "gemini-2.5-pro",
                displayName: "Gemini 2.5 Pro",
                contextWindow: 1000000,
                inputCostPer1M: 1.25,
                outputCostPer1M: 10,
            },
            {
                id: "gemini-2.0-flash",
                displayName: "Gemini 2.0 Flash",
                contextWindow: 1000000,
                inputCostPer1M: 0.1,
                outputCostPer1M: 0.4,
            },
        ],
    },
    ollama: {
        name: "ollama",
        displayName: "Ollama (Local)",
        supportsStreaming: true,
        supportsTools: true,
        models: [
            {
                id: "llama3.2",
                displayName: "Llama 3.2",
                contextWindow: 128000,
                inputCostPer1M: 0,
                outputCostPer1M: 0,
            },
            {
                id: "qwen2.5-coder:7b",
                displayName: "Qwen 2.5 Coder 7B",
                contextWindow: 128000,
                inputCostPer1M: 0,
                outputCostPer1M: 0,
            },
        ],
    },
};
//# sourceMappingURL=provider.js.map